import { FC } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectFloorsCountFilter } from 'shared/selectors/advancedFilters';

export const FloorsCountContainer: FC = () => {
  const { label, valueMax, valueMin, max, min } = useSelector(selectFloorsCountFilter);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setFloorsMin', arguments: [value] });
  });

  const handleMaxChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setFloorsMax', arguments: [value] });
  });

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilter width={100}>
        <RangeInput
          min={min}
          max={max}
          valueMin={valueMin}
          valueMax={valueMax}
          onChangeMin={handleMinChange}
          onChangeMax={handleMaxChange}
        />
      </InlineFilter>
    </AdvancedFilterRow>
  );
};
